module.exports = __webpack_public_path__ + "img/cx.43b253d1.svg";